module.exports = __webpack_public_path__ + "img/blockchain_md.cdb5b510.png";